import { makeEnvironmentProviders } from '@angular/core';
import { ShowErrorService } from '@core/services';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { errorInterceptor, headersInterceptor } from '@core/interceptors';
import { authInterceptor } from '@core/interceptors/auth.interceptor';

export function provideHttpModule() {
  return makeEnvironmentProviders([
    ShowErrorService,
    provideHttpClient(withInterceptors([errorInterceptor, authInterceptor, headersInterceptor])),
  ]);
}
